/* eslint-disable jsx-a11y/media-has-caption */
import React from "react";
import { useAppStore } from "../../../appStore";
import { createSiteHyperlink } from "../Alerts/AlertsUtils/createSiteHyperlink";
import { createCameraHyperlink } from "../Alerts/AlertsUtils/createCameraHyperlink";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { LoadingSpinner } from "../../common/LoadingSpinner";
import { CircularProgress } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FrontelTable } from "./FrontelTable";
import { saveAs } from "file-saver";
import { PrecisionAndRecallTableFrontel } from "./PrecisionAndRecallTableFrontel";
import { ShowMoreDialogFrontel } from "./ShowMoreDialogFrontel";
import { ClipVerificationBoxFrontel } from "./ClipVerificationBoxFrontel";
import ErrorBoundary from "../../../ErrorBoundary";
import { handleButtonShadingFrontel } from "./ClipsUtilities/handleButtonShadingFrontel";
import { removeClipsIdParamsFromUrl } from "./ClipsUtilities/clipsUrlParams";
import { ShareClipUrlButton } from "./ShareClipUrlButton";

declare module "@mui/material/styles" {
  interface Palette {
    neutral: Palette["primary"];
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});

export const FrontelTab = ({
  navBarCollapsed,
}: {
  navBarCollapsed: boolean;
}) => {
  const { userPermissions } = useAppStore();

  const {
    selectedRowFrontel,
    fetchingFilteredDataFrontel,
    loadingAdditionalDataFrontel,
    videoClipLoadingFrontel,
    videoURLFrontel,
    frontelSite,
    frontelData,
    setFrontelData,
    setSelectedRowFrontel,
    setVideoClipLoadingFrontel,
    getClipInfoFrontel,
    getVideoURLFrontel,
    precisionRecallDataFrontel,
    showMoreDialogOpenFrontel,
    setShowMoreDialogOpenFrontel,
    verifiedClickedFrontel,
    unverifiedClickedFrontel,
    setVerifiedClickedFrontel,
    setUnverifiedClickedFrontel,
    frontelUsername,
    userFiltersFrontel,
    groupIDFrontel,
  } = useClipsStore();

  const [order, setOrder] = React.useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = React.useState("formatted_date");

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <div
      className={
        navBarCollapsed
          ? userPermissions.sentinel ||
            userPermissions.ailink ||
            userPermissions.frontel
            ? "relative left-[75px] top-[150px] w-[600px]"
            : "relative left-[75px] top-[90px] w-[600px]"
          : userPermissions.sentinel ||
            userPermissions.ailink ||
            userPermissions.frontel
          ? "relative left-[150px] top-[150px] w-[600px]"
          : "relative left-[150px] top-[90px] w-[600px]"
      }
    >
      <p className="relative left-[20px] top-[15px] text-actuate-blue font-mulish text-[20px]">
        {frontelSite.site_name
          ? createSiteHyperlink(frontelSite.site_name, frontelSite.site_id)
          : ""}
        {frontelSite.site_name && selectedRowFrontel.camera_name ? " | " : " "}
        {createCameraHyperlink(
          selectedRowFrontel.camera_name,
          frontelSite.site_id,
          selectedRowFrontel.camera_id
        )}
      </p>
      <div className="flex pt-[20px] pl-[10px]">
        <div>
          {!fetchingFilteredDataFrontel && (
            <div>
              <div>
                <div className={!navBarCollapsed ? "w-[745px]" : "w-[815px]"}>
                  <FrontelTable
                    order={order}
                    orderBy={orderBy}
                    setOrder={setOrder}
                    setOrderBy={setOrderBy}
                  />
                </div>
                {loadingAdditionalDataFrontel && (
                  <div className="relative pt-[5px]">
                    <div className="relative left-[10px]">
                      <LoadingSpinner />
                    </div>
                    <p className="absolute left-[58px] top-[7px] font-mulish text-actuate-orange">
                      Loading Additional Data
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div>
          <div className="w-[660px]">
            <div className="w-[660px]">
              <div>
                {videoClipLoadingFrontel && (
                  <div className="text-center">
                    <ThemeProvider theme={theme}>
                      <div>
                        <CircularProgress color="primary" />
                      </div>
                      <br></br>
                      <p className="font-mulish text-[20px]">
                        Video Loading...
                      </p>
                    </ThemeProvider>
                  </div>
                )}
                {!videoClipLoadingFrontel && (
                  <div className="flex items-center justify-between w-[660px]">
                    <div className="flex-none" id="arrow_back">
                      <OrangeTextButton
                        onClick={() => {
                          const currentIndex = frontelData.findIndex(
                            (item: any) =>
                              item.file_id === selectedRowFrontel.file_id
                          );
                          if (currentIndex > 0) {
                            const prevRow = frontelData[currentIndex - 1];
                            // Update selection in data
                            const updatedData = frontelData.map(
                              (item: any) => ({
                                ...item,
                                selected: item.file_id === prevRow.file_id,
                              })
                            );
                            setFrontelData(updatedData);
                            setSelectedRowFrontel(prevRow);
                            setVideoClipLoadingFrontel(true);
                            handleButtonShadingFrontel(
                              prevRow,
                              setVerifiedClickedFrontel,
                              setUnverifiedClickedFrontel
                            );
                            getClipInfoFrontel(prevRow.file_id, navigate);
                            getVideoURLFrontel(prevRow.file_id, navigate);
                            removeClipsIdParamsFromUrl(
                              setSearchParams,
                              searchParams
                            );
                          }
                        }}
                        text={
                          <ArrowBackIosIcon fontSize="large" id="BackButton" />
                        }
                        disabled={
                          frontelData.length === 0 ||
                          frontelData.findIndex(
                            (item: any) =>
                              item.file_id === selectedRowFrontel.file_id
                          ) === 0
                        }
                      />
                    </div>
                    <div className="flex-auto" id="video">
                      <React.Fragment>
                        <video width="550" autoPlay controls loop>
                          <source src={videoURLFrontel} type="video/mp4" />
                        </video>
                      </React.Fragment>
                      <div className="flex gap-[16px]">
                        <OrangeTextButton
                          onClick={() => saveAs(videoURLFrontel, "video.mp4")}
                          text="Download Video"
                          disabled={false}
                        />
                        <ShareClipUrlButton
                          tab="frontel"
                          selectedRow={selectedRowFrontel}
                        />
                        <ShowMoreDialogFrontel
                          showMoreDialogOpenFrontel={showMoreDialogOpenFrontel}
                          setShowMoreDialogOpenFrontel={
                            setShowMoreDialogOpenFrontel
                          }
                          selectedRowFrontel={selectedRowFrontel}
                          videoURLFrontel={videoURLFrontel}
                        />
                      </div>
                    </div>
                    <div className="flex-none" id="arrow_forward">
                      <OrangeTextButton
                        onClick={() => {
                          const currentIndex = frontelData.findIndex(
                            (item: any) =>
                              item.file_id === selectedRowFrontel.file_id
                          );
                          if (currentIndex < frontelData.length - 1) {
                            const nextRow = frontelData[currentIndex + 1];
                            // Update selection in data
                            const updatedData = frontelData.map(
                              (item: any) => ({
                                ...item,
                                selected: item.file_id === nextRow.file_id,
                              })
                            );
                            setFrontelData(updatedData);
                            setSelectedRowFrontel(nextRow);
                            setVideoClipLoadingFrontel(true);
                            handleButtonShadingFrontel(
                              nextRow,
                              setVerifiedClickedFrontel,
                              setUnverifiedClickedFrontel
                            );
                            getClipInfoFrontel(nextRow.file_id, navigate);
                            getVideoURLFrontel(nextRow.file_id, navigate);
                            removeClipsIdParamsFromUrl(
                              setSearchParams,
                              searchParams
                            );
                          }
                        }}
                        text={
                          <ArrowForwardIosIcon
                            fontSize="large"
                            id="forwardButton"
                          />
                        }
                        disabled={
                          frontelData.length === 0 ||
                          frontelData.findIndex(
                            (item: any) =>
                              item.file_id === selectedRowFrontel.file_id
                          ) ===
                            frontelData.length - 1
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
              {/* <div className="pt-[10px] pl-[30px]">
                {!videoClipLoadingFrontel && (
                  <ErrorBoundary>
                    <ClipVerificationBoxFrontel
                      verifiedClicked={verifiedClickedFrontel}
                      unverifiedClicked={unverifiedClickedFrontel}
                      setVerifiedClicked={setVerifiedClickedFrontel}
                      setUnverifiedClicked={setUnverifiedClickedFrontel}
                      selectedRow={selectedRowFrontel}
                      clipsData={frontelData}
                      setClipsData={setFrontelData}
                      setSelectedRow={setSelectedRowFrontel}
                      setPageLoading={() => {}}
                      navBarCollapsed={navBarCollapsed}
                      navigate={navigate}
                      frontelUsername={frontelUsername}
                    />
                  </ErrorBoundary>
                )}
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <br></br>
      <div
        className={
          !navBarCollapsed
            ? "bg-white h-[55px] w-[1305px]"
            : "bg-white h-[55px] w-[1380px]"
        }
      >
        <div className="bg-white h-[55px]">
          <p className="font-black font-mulish text-[20px] p-3 indent-4">
            Precision and Recall
          </p>
        </div>
        <PrecisionAndRecallTableFrontel
          precisionRecallData={precisionRecallDataFrontel}
        />
      </div>
    </div>
  );
};
